import { render, staticRenderFns } from "./mobile-aside-marketing.vue?vue&type=template&id=5c6a94b7&"
import script from "./mobile-aside-marketing.vue?vue&type=script&lang=js&"
export * from "./mobile-aside-marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports